import { jsx as _jsx } from "react/jsx-runtime";
import colors from "../../../../theme/tokens/colors";
import Loading from "../../../Loading";
const DropdownOverlayLoading = () => (_jsx("div", { className: "flex h-52 items-center justify-center px-5", children: _jsx(Loading, { fill: colors.gray.DEFAULT }) }));
export default DropdownOverlayLoading;
